import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';
import { AddTeamService } from "./add-team";

export class InviteAgencyUserService extends SendRequest
{
    async userListData(slug, params)
    {
        return await new AddTeamService().getUserListData(slug, params);   
    }

    async getAgencyUserRoles(params, hostName)
    {
      const url        = API.client.company.GET_AGENCY_USER_ROLES;
      var   header     = this.serverSideHeaderJSON(hostName);
      header["cookie"] = `Authorization=${params.token}`;
      
      try 
      {
            const result = await axios.get(url,
            {
              params: params,
              headers: header
            },
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
        return result;
      } 
      catch (error) 
      { 
        return error;
      }

    }

    async addMembers(params)
    {
        const url = API.client.company.ADD_CLIENTS;

        try {
             const result = await axios.post( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async inviteUsers(params, agency_id)
    {
        const url = API.client.company.INVITE_AGENCY_USER.replace('$agency_id', agency_id);

        try {
             const result = await axios.post( url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }
}